import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { useLocation, useNavigate } from "react-router-dom";
import { studentBusEnroll } from "../../api/Student";
import Master from "./Master";
import useAppConfig from "../config/useAppConfig";
import { busList, busStopsList } from "../../api/Transport";

export default function StudentEnrollBus() {
    const navigate = useNavigate();
    const config = useAppConfig("RTE", "rte_workflow");
    const [loading, setLoading] = useState(false);
    const [sessions, setSessions] = useState([]);
    const [bus, setBus] = useState([]);
    const [busStop, setBusStop] = useState([]);
    const [data, setData] = useState({});

    const location = useLocation();
    const queryParam = new URLSearchParams(location.search);
    const student_id = queryParam.get("student_id");



    const getBusList = async () => {
        setLoading(true);
        try {
            let addUrl = ``;
            const response = await busList(addUrl);
            if (response.data.status) {
                setBus(response?.data?.data);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.response?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };
    const getBusStops = async () => {
        setLoading(true);
        try {
            let addUrl = ``;

            if (data?.bus_id) {
                addUrl += `bus_id=${data?.bus_id}`;
            }

            if (data?.session_id) {
                addUrl += `${addUrl ? "&" : ""}session_id=${data?.session_id}`;
            }

            const response = await busStopsList(addUrl);

            if (response.data.status) {
                setBusStop(response?.data?.data?.data || []);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.response?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
        setSessions(parseSessions);
    }, []);

    useEffect(() => {
        setData({
            ...data,
            session_id: sessions?.find((s) => Number(s.status) === 1)?.id,
        });
    }, [sessions]);

    useEffect(() => {
        getBusList();
    }, [data?.session_id]);

    useEffect(() => {
        if (data?.bus_id && data?.session_id) {
            getBusStops();
        }
    }, [data?.bus_id, data?.session_id]);




    useEffect(() => {

        if (data?.bus_stop_id) {

            const selectedRoute = busStop?.find(
                (b) => Number(b.id) === Number(data?.bus_stop_id)
            );

            if (!selectedRoute) return;

            const originalFee = Number(selectedRoute?.stop_fee || 0);

            let finalFee = originalFee;

            // RTE CONFIG
            let rteConfig = [];

            try {

                rteConfig = JSON.parse(config?.value || "[]");

                if (typeof rteConfig === "string") {
                    rteConfig = JSON.parse(rteConfig);
                }

            } catch (e) {
                rteConfig = [];
            }
            if (data?.student_type === "RTE") {

                const transportFree = rteConfig?.find(
                    (x) =>
                        x.key === "transport_fee" &&
                        Number(x.value) === 1
                );

                if (transportFree) {
                    finalFee = 0;
                }
            }

            setData((prev) => ({
                ...prev,
                stop_fee: originalFee,
                final_fee: finalFee,
                discount: originalFee - finalFee,
                duration: selectedRoute?.duration || "",
            }));
        }

    }, [data?.bus_stop_id, data?.student_type, config, busStop]);

    const handleAdd = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const formData = new FormData(e.target);
            const response = await studentBusEnroll(formData);
            if (response?.data?.status) {
                navigate(`/student/details?id=${student_id}`);
                SweetAlertShow("success", "Successfully", response?.data?.message);
            } else {
                SweetAlertShow("info", "warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ??
                error?.response?.message ??
                error?.message
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <LoadingDiv />}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid flex-grow-1 container-p-y">
                                <div className="row">
                                    <Master />
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h4 className="text-primary mb-0">
                                                    Student Bus Enroll
                                                </h4>
                                                <hr />
                                                <form onSubmit={handleAdd} method="post">
                                                    <div className="row g-3">

                                                        <input
                                                            type="hidden"
                                                            name="student_id"
                                                            value={student_id}
                                                        />

                                                        <div className="col-md-4">
                                                            <div className="form-floating form-floating-outline">
                                                                <select
                                                                    className="form-select"
                                                                    name="session_id"
                                                                    value={data?.session_id || ""}
                                                                    onChange={(e) =>
                                                                        setData({
                                                                            ...data,
                                                                            session_id: e.target.value,
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="">Select Session</option>

                                                                    {sessions?.map((session) => (
                                                                        <option
                                                                            key={session?.id}
                                                                            value={session?.id}
                                                                        >
                                                                            {session?.session}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                                <label>Select Session</label>
                                                            </div>
                                                        </div>

                                                        {/* BUS */}
                                                        <div className="col-md-4">
                                                            <div className="form-floating form-floating-outline">
                                                                <select
                                                                    className="form-select"
                                                                    name="bus_id"
                                                                    value={data?.bus_id || ""}
                                                                    onChange={(e) =>
                                                                        setData({
                                                                            ...data,
                                                                            bus_id: e.target.value,
                                                                            bus_stop_id: "",
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="">Select Bus</option>

                                                                    {bus?.map((item) => (
                                                                        <option key={item?.id} value={item?.id}>
                                                                            {item?.bus_number}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                                <label>Select Bus</label>
                                                            </div>
                                                        </div>

                                                        {/* ROUTE */}
                                                        <div className="col-md-4">
                                                            <div className="form-floating form-floating-outline">
                                                                <select
                                                                    className="form-select"
                                                                    name="bus_stop_id"
                                                                    value={data?.bus_stop_id || ""}
                                                                    onChange={(e) => {

                                                                        const routeId = e.target.value;

                                                                        setData((prev) => ({
                                                                            ...prev,
                                                                            bus_stop_id: routeId,
                                                                        }));
                                                                    }}
                                                                >
                                                                    <option value="">Select Stop</option>

                                                                    {busStop?.map((s) => (
                                                                        <option key={s?.id} value={s?.id}>
                                                                            {s?.stop_name}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                                <label>Select Stop</label>
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-sm-4">
                                                            <div className="form-floating form-floating-outline">
                                                                <select
                                                                    className="form-select"
                                                                    name="student_type"
                                                                    value={data?.student_type || "NONRTE"}
                                                                    onChange={(e) =>
                                                                        setData({
                                                                            ...data,
                                                                            student_type: e.target.value,
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="NONRTE">
                                                                        NON-RTE Student
                                                                    </option>
                                                                    <option value="RTE">RTE Student</option>
                                                                </select>

                                                                <label>Select Student Type</label>
                                                            </div>
                                                        </div> */}

                                                        {data?.bus_stop_id && (
                                                            <>
                                                                <div className="col-md-4">
                                                                    <div className="form-floating form-floating-outline">
                                                                        <select
                                                                            className="form-select"
                                                                            name="payment_type"
                                                                            value={data?.payment_type || ""}
                                                                            onChange={(e) =>
                                                                                setData({
                                                                                    ...data,
                                                                                    payment_type: e.target.value,
                                                                                })
                                                                            }
                                                                        >
                                                                            <option value="">Select Payment Type</option>
                                                                            <option value="Monthly">Monthly</option>
                                                                            <option value="Quarterly">Quarterly</option>
                                                                            <option value="Half">Half Yearly</option>
                                                                            <option value="Full">Full</option>
                                                                        </select>

                                                                        <label>Payment Type</label>
                                                                    </div>
                                                                </div>

                                                                {/* START DATE */}
                                                                <div className="col-md-4">
                                                                    <div className="form-floating form-floating-outline">
                                                                        <input
                                                                            type="date"
                                                                            className="form-control"
                                                                            name="start_date"
                                                                            value={data?.start_date || new Date().toISOString().split("T")[0]}
                                                                            onChange={(e) =>
                                                                                setData({
                                                                                    ...data,
                                                                                    start_date: e.target.value,
                                                                                })
                                                                            }
                                                                        />

                                                                        <label>Start Date</label>
                                                                    </div>
                                                                </div>

                                                                {/* BUS FEE */}
                                                                <div className="col-md-4">
                                                                    <div className="form-floating form-floating-outline">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            name="stop_fee"
                                                                            value={data?.stop_fee || ""}
                                                                            readOnly
                                                                        />

                                                                        <label>Stop Fee</label>
                                                                    </div>
                                                                </div>

                                                                {/* FINAL FEE */}
                                                                <div className="col-md-4">
                                                                    <div className="form-floating form-floating-outline">
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            name="final_fee"
                                                                            placeholder="Final Fee"
                                                                            value={data?.final_fee ?? ""}
                                                                            readOnly={data?.student_type === "RTE"}
                                                                            onChange={(e) => {

                                                                                let finalFee = Number(e.target.value || 0);
                                                                                const stopFee = Number(data?.stop_fee || 0);

                                                                                // minus me nahi jane dena
                                                                                if (finalFee < 0) {
                                                                                    finalFee = 0;
                                                                                }

                                                                                // bus fee se jyada nahi
                                                                                if (finalFee > stopFee) {
                                                                                    finalFee = stopFee;
                                                                                }

                                                                                setData((prev) => ({
                                                                                    ...prev,
                                                                                    final_fee: finalFee,
                                                                                    discount: stopFee - finalFee,
                                                                                }));
                                                                            }}
                                                                        />

                                                                        <label>Final Fee</label>
                                                                    </div>
                                                                </div>

                                                                {/* DISCOUNT */}
                                                                {Number(data?.discount || 0) > 0 &&
                                                                    data?.student_type !== "RTE" && (
                                                                        <div className="col-md-4">
                                                                            <div className="form-floating form-floating-outline">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control input-uppercase"
                                                                                    name="discount_remark"
                                                                                    placeholder="Discount Remark"
                                                                                    required
                                                                                />

                                                                                <label>Discount Remark</label>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                {/* REMARK */}
                                                                <div className="col-md-4">
                                                                    <div className="form-floating form-floating-outline">
                                                                        <textarea
                                                                            className="form-control input-uppercase"
                                                                            name="remark"
                                                                            placeholder="Remark"
                                                                            rows={4}
                                                                            style={{ height: "120px" }}
                                                                        ></textarea>

                                                                        <label>Remark</label>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* BUTTON */}
                                                        <div className="col-12 text-end">
                                                            <button className="btn btn-primary px-5">
                                                                Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
